import { Injectable } from '@angular/core';
import { CommunicationManagerService } from './communication-manager.service';
import { map, switchMap, tap } from 'rxjs/operators';
import { BankAccount } from './../models/bank-account';
import { Observable, of } from 'rxjs';
import { LocalStorageService } from './storage.service';

type BankAccountSave = Omit<
  BankAccount,
  '_id' | 'createdAt' | 'isDebit' | 'endDate' | 'isFavorite' | 'deletedAt'
>;

@Injectable({
  providedIn: 'root',
})
export class BankAccountService {
  constructor(
    private cm: CommunicationManagerService,
    private ls: LocalStorageService
  ) {}

  getAllBankAccountsForCompany(companyId: string) {
    return this.cm
      .get('bankAccount', [{ headerName: 'companyId', headerValue: companyId }])
      .pipe(
        map((accounts) => {
          return (accounts as Array<BankAccount>).filter(
            (account) => account.company === companyId // TODO: do we need this?
          ); //TODO filtering on the Back end
        })
      );
  }

  //TODO we have period calculation, annotate method and expain params
  calculateAllBankAccountHistoriesForCompany(
    companyId: string,
    bankAccountId?: string,
    fromDate?: Date,
    toDate?: Date
  ): Observable<any> {

    let payload: {bankAccountId?: string, startDate?: string, endDate?: string} = {bankAccountId};
    
    if(fromDate && toDate){
      // Convert fromDate to string in 'MM-DD-YYYY' format
      let dd = String(fromDate.getDate()).padStart(2, '0');
      let mm = String(fromDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      let yyyy = fromDate.getFullYear();
      const startDate = `${mm}-${dd}-${yyyy}`;

      // Convert toDate to string in 'MM-DD-YYYY' format
      dd = String(toDate.getDate()).padStart(2, '0');
      mm = String(toDate.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      yyyy = toDate.getFullYear();
      const endDate = `${mm}-${dd}-${yyyy}`;

      payload = {
        bankAccountId,
        startDate,
        endDate
      }
    }
      return this.cm
        .postAndGetJson(`bankAccount/calculateHistory`, payload, [
          { headerName: 'companyId', headerValue: companyId },
        ])
        .pipe(
          switchMap(() => {
            this.ls.setBankAccountCalculatedHistory();
            return of(1); // Emit the desired value
          })
        );
  }

  calculateAllBankAccountHistoriesForCompanyForYear(
    companyId: string,
    year: number
  ) {
    //not implemented
  }

  createBankAccount(
    bankAccount: BankAccountSave,
    companyId: string
  ): Observable<BankAccount> {
    return this.cm.postAndGetJson(`bankAccount`, bankAccount, [
      { headerName: 'companyId', headerValue: companyId },
    ]) as Observable<BankAccount>;
  }

  updateBankAccount(
    bankAccount: BankAccountSave,
    bankAccountId: string,
    companyId: string
  ): Observable<BankAccount> {
    return this.cm.put(`bankAccount/${bankAccountId}`, bankAccount, [
      { headerName: 'companyId', headerValue: companyId },
    ]) as Observable<BankAccount>;
  }
}
